import React from 'react';

/**
 * PlanTimeInfo Component
 * Formatteert tijdsinformatie en toont:
 * "<ingeplande tijd> van <beschikbare tijd>: <tijd over of tekort> [<aantal taken>]"
 */
const PlanTimeInfo = ({ plannedTime, plannableTime, planItems, availableTime }) => {
  // Bereken of er tijd over is of een tekort
  const difference = plannableTime - plannedTime;
  
  // Formateer tijdsverschil in uren of minuten
  let timeDisplay;
  if (Math.abs(difference) >= 1) {
    // Meer dan een uur: toon in uren met 1 decimaal
    timeDisplay = `${Math.abs(difference).toFixed(1)} uur ${difference >= 0 ? 'te gaan' : 'tekort'}`;
  } else {
    // Minder dan een uur: toon in minuten
    timeDisplay = `${Math.round(Math.abs(difference) * 60)} min ${difference >= 0 ? 'te gaan' : 'tekort'}`;
  }

  // Aantal taken
  const taskCount = Array.isArray(planItems) ? planItems.length : 0;

  return (
    <div className="plan-time-info">
      {plannedTime.toFixed(2)} van {plannableTime.toFixed(2)} ({availableTime.toFixed(2)}): {timeDisplay} [{taskCount}]<br/>
    </div>
  );
};

export default PlanTimeInfo;
